





























import Vue from 'vue'
import { portalState } from '@/state'

export default Vue.extend({
  name: 'BusinessActions',
  props: { selectedBusiness: Object, tab: String, selectedEntitiesLength: Number },
  computed: { loggedInUser () { return portalState.user } }
})
